import { QueryOptions, UseQueryOptions } from 'react-query';
import { getAllOrgs, getOrgDetails, searchOrgs } from './orgs.api';
import {
  AllOrgsResponse,
  OrgDetailResponse,
  SearchOrgsResponse,
} from './orgs.schema';

export const ORGS_QUERY_KEY_PREFIX = 'orgs';

export const getAllOrgsQuery = (
  populate: boolean = false,
): QueryOptions<AllOrgsResponse> => ({
  queryKey: [ORGS_QUERY_KEY_PREFIX, { populate }],
  queryFn: () => getAllOrgs(populate),
});

export const searchOrgsQuery = (
  name: string,
): UseQueryOptions<SearchOrgsResponse> => ({
  queryKey: [ORGS_QUERY_KEY_PREFIX, { search: name }],
  queryFn: () => searchOrgs(name),
  enabled: name.trim().length >= 2,
});

export const getOrgDetailsQuery = (
  orgId: number,
): QueryOptions<OrgDetailResponse> => ({
  queryKey: [ORGS_QUERY_KEY_PREFIX, { orgId }],
  queryFn: () => getOrgDetails(orgId),
});
